import React, { Component } from 'react';

import MessageWindow from '../../Elements/Snackbar/MessageWindow'
import {messageWindow} from '../../Elements/Snackbar/MessageWindow'

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';

import {localization} from '../../Frames/localization'
import TablePagination from '@material-ui/core/TablePagination';

const classes = {
    root: {
      minHeight: 520,
      maxHeight: 520,
      overflowX: 'auto',
      rows: null,
    },
    };
  class SimpleTable extends Component {
    constructor(props)
   {
     super(props)
     
     this.state = {
      listProduct:  undefined,
      listProductLoad: false,
      checked: null,
      prod_id: this.props.prod_id,
      page: 0,
      rowsPerPage: 100,
      Count: 0    
     }
     this.handleToggle = this.handleToggle.bind(this)
   }
  createData(ExtSku, id, checked) {
    if(checked == true)
    {
      this.state.Count++; 
    }
    return { ExtSku, id, checked };
  }
   Data(props)
   {
    var rows = 
       props.data.ExtCodes.map(item => (
         this.createData(item.name, item.id, this.Contains(item))
       ))
     return rows;
   }
   componentDidMount()
   {
    this.setState({rows: this.Data(this.props)});
   }
   handleToggle(value)
  {
    if(value.checked == true)
    {
      this.state.Count--;
      value.checked = false;
    }
    else if(value.checked == false)
    {
      if(this.state.Count >= this.props.position)
      {
        messageWindow.OpenMessage("warning", localization.GetTranslate('Cashback.selectMax'))
        this.setState({key: Math.random()})
      }else
      {
        this.state.Count++;
        value.checked = true;
      }

    }
      this.forceUpdate()
  }
  Contains(value)
  {
    var prod = this.state.prod_id.split(',');
    for(var j=0; j < prod.length; j++)
    {
        if(prod[j] == value.id)
        {
          return true;
        }
    }
    return false;
  }
    handleChangePage = (event, newPage) => {
      this.state.page = newPage;
      this.forceUpdate()
    };
  
    handleChangeRowsPerPage = event => {
      this.state.rowsPerPage = +event.target.value;
      this.state.page = 0;
      this.forceUpdate()
    };
    render(){
      const {page, rowsPerPage} = this.state;
      var tr = {
        date: localization.GetTranslate('Statistics.Date'),
        quantity: localization.GetTranslate('Statistics.Number'),
        sum: localization.GetTranslate('Statistics.sum'),
        of: localization.GetTranslate('Statistics.of')
      }
    return (
        <div className={this.props.className}>
            <List id={"List-"+this.props.id} style={classes.root}>
                {this.state.rows &&
                this.state.rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(value => {
                  const labelId = `checkbox-list-label-${value.id}`;
                  return (
                    <ListItem disabled={this.props.disable} key={value.id} role={undefined} dense button onClick={() => this.handleToggle(value)}>
                      <ListItemIcon>
                        <Checkbox
                          type="checkbox"
                          edge="start"
                          id={value.id}
                          value={value.id}
                          name={value.id}
                          color="primary"
                          checked={value.checked}
                          tabIndex={-1}
                          disableRipple
                          disabled={this.props.disable}
                          inputProps={{ 'aria-labelledby': labelId }}
                        />
                      </ListItemIcon>
                      <ListItemText className="checked" id={labelId} primary={`${value.ExtSku}`} />
                    </ListItem>
                  );
                })}
              </List>
              {this.state.rows &&
              <TablePagination
                  rowsPerPageOptions={[10, 25, 100]}
                  component="div"
                  count={this.state.rows.length}
                  rowsPerPage={this.state.rowsPerPage}
                  page={this.state.page}
                  labelRowsPerPage={tr.quantity}
                  backIconButtonProps={{
                    'aria-label': 'previous page',
                  }}
                  labelDisplayedRows={({ from, to, count }) => `${from}-${to} ${tr.of} ${count}`}
                  nextIconButtonProps={{
                    'aria-label': 'next page',
                  }}
                  onChangePage={this.handleChangePage}
                  onChangeRowsPerPage={this.handleChangeRowsPerPage}
                  classes={{
                    root: "rootPagination",
                    caption: "rootPagination",
                    selectIcon: "rootPagination",
                    select: "rootPagination",
                    actions: "rootPagination",
                  }}
                />
                }
                <MessageWindow key={this.state.key} ></MessageWindow>
      </div>
    );
  }
}
export default SimpleTable;